import { PluginRegistrationProps } from "./register-plugins";

export class TextTemplateInfo {
  text: string = "";
  template: string = "";
  children: TextTemplateInfo[] = []
}

export default function TextTemplatePlugin({ editor }: PluginRegistrationProps) {
  let buttonName = editor.getParam("texttemplate_button_text");
  let templates = editor.getParam("texttemplate_items");

  let buildButtonMenuForButton = (temps: TextTemplateInfo[]): any[] => {
    if (temps.length === 0) return [];
    return temps.map((t) => {
      let newItem = {
        type: t.children.length > 0 ? 'nestedmenuitem' : 'menuitem',
        text: t.text,
        onAction: () => editor.insertContent(t.template),
        getSubmenuItems: () => buildButtonMenuForButton(t.children)
      };
      return newItem;
    });
  }

  editor.ui.registry.addMenuButton('texttemplates', {
    text: buttonName || 'Templates',
    fetch: (callback) => {
      const items: any[] = buildButtonMenuForButton(templates)
      callback(items);
    }
  });
};

